import Axios from 'axios'

const axios = Axios.create({
  baseURL: 'https://api.voiss.cc',
  headers: {
    Authorization: 'Bearer Q1eaC7uerpzJUktXTtRWDsRfjW7Zm2aXCwHDHoKA'
  }
})

/**
 * @typedef {Object} Mind524ApiResults
 * @property {Object} next
 * @property {Array} actions
 */
/**
 * @typedef {Object} Mind524S2PageData
 * @property {String} text
 */

/**
 * @param {*} sid
 * @param {*} scene
 * @returns {Mind524ApiResults}
 */
export async function storyContinue (sid, scene, opts = {}) {
  scene = scene || 'S1'
  const { text, data, userId, audio } = opts
  const qid = scene === 'S1' ? 'prologue' : 'end'
  const current = scene === 'S2' ? { qid, data } : null
  // const reqOpts = {
  //   headers: { 'Content-Type': 'application/json' }
  // }
  const fd = new FormData()
  const reqData = {
    storyId: sid,
    convId: opts.convId,
    userId,
    text,
    audio,
    hasAudio: opts.hasAudio
  }
  for (const key in reqData) {
    if (reqData[key]) {
      fd.append(key, reqData[key])
    }
  }
  if (current) {
    fd.append('current', JSON.stringify(current))
  }
  const res = await axios.post('/mind524/story', fd)
  return res.data
}

export async function getUserStt (audio, convId) {
  const fd = new FormData()
  fd.append('audio', audio)
  if (convId) {
    fd.append('convId', convId)
  }
  const res = await axios.post('/mind524/story/stt', fd)
  return res.data
}

export function saveLoginToken (token) {
  window.localStorage.setItem('m524-token', token)
}

export function getLoginToken () {
  return window.localStorage.getItem('m524-token')
}

export function saveNickname (name) {
  window.localStorage.setItem('m524-nickname', name)
}

export function getNickname () {
  let name = ''
  try {
    name = window.localStorage.getItem('m524-account') ||
      window.localStorage.getItem('m524-nickname') ||
      ''
  } catch (e) {
    console.error(e)
  }
  return name
}

/**
 * 紀錄編輯的文字
 */
export async function updateReviewText (convId, storyId, reviewText) {
  const res = await axios.post('/mind524/edit/review', {
    convId,
    storyId,
    text: reviewText
  })
  return res.data
}

/**
 * 選擇的 feedback 選項
 */
export async function updateFeedbackRating (convId, storyId, rating1, rating2) {
  const res = await axios.post('/mind524/edit/feedback-rating', {
    convId,
    storyId,
    rating1,
    rating2
  })
  return res.data
}

/**
 * 選擇的 feedback 選項
 */
export async function updateFeedbackMsg (convId, storyId, content, content2) {
  const res = await axios.post('/mind524/edit/feedback-msg', {
    convId,
    storyId,
    content,
    nContent: content2
  })
  return res.data
}

/**
 * 選擇的 feedback 選項
 */
export async function updateFeedback (convId, storyId, feedback) {
  const res = await axios.post('/mind524/edit/feedback', {
    convId,
    storyId,
    feedback
  })
  return res.data
}

let s2PageData = null
export async function updateS2PageData (data) {
  if (!s2PageData) {
    const raw = window.localStorage.getItem('s2-page-data')
    try {
      s2PageData = JSON.parse(raw)
    } catch (e) {
      // ..
    }
  }
  if (s2PageData) {
    Object.assign(s2PageData, data)
    await saveS2PageData(s2PageData)
  }
  return data
}

export async function saveS2PageData (data) {
  s2PageData = data
  console.log('save s2 page data', data)
  try {
    window.localStorage.setItem('s2-page-data', JSON.stringify(data))
  } catch (e) {
    console.warn('無法存取 local storage')
  }
}

/**
 * @returns {Mind524S2PageData}
 */
export async function getS2PageData () {
  if (s2PageData) {
    return s2PageData
  } else {
    try {
      const raw = window.localStorage.getItem('s2-page-data')
      return JSON.parse(raw)
    } catch (e) {
      console.warn('無法存取 local storage')
    }
    return null
  }
}
